import { PropsWithChildren } from "react";

export function Layout({ children }: PropsWithChildren) {
  return (
    <div className={"flex min-h-screen flex-col bg-slate-100"}>
      {children ?? null}
    </div>
  );
}
